import React,{Fragment, Component} from "react";
import {FaChevronUp, FaChevronDown , FaTrash , FaEye} from "react-icons/fa";
import {withRouter} from "react-router-dom";
class Cart extends Component{
        state={
            nights: 1,
            currentPrice: 0
        
    }
    componentDidMount=()=>{
        this.setState({
            currentPrice: this.props.room.price
        });
    }
    render(){
        const {name, price , capacity, size, images, slug, id} = this.props.room;
        const handlePriceChange=(method)=>{
            if(method === "increase" && this.state.nights < 10){
                this.setState(function (prevState){
                    return{
                       nights: prevState.nights +1,
                        currentPrice: prevState.currentPrice  + this.props.room.price 
                    }
                    
                });
            }else if(method === "decrease" && this.state.nights >1){
                this.setState( prevState =>({
                    nights: prevState.nights - 1,
                    currentPrice: prevState.currentPrice - this.props.room.price
                }));
            }
            setTimeout(()=>{
                this.props.accumulator(this.state.currentPrice, id );
            },300);
            
        }
        const redirectToSingleRoom=()=>{
            this.props.history.push(`/rooms/${slug}#top`);
        }
    
        return(
            <Fragment>
                <tbody>
                    <tr>
                        <td style={{lineHeight:"158px"}} className="firsttd"><strong>{this.props.index}</strong></td>
                        <td>
                            
                            <div style={{display:"flex"}}>
                                <img className="cart-img" src={images[0]} alt={name}/>
                                
                                <div style={{display:"block"}}>
                                    <h4 style={{textTransform: "capitalize"}}>{name}</h4>
                                    <p>Size : {size} SQFT</p>
                                    <p>${price}</p>
                                    <p>Capacity : {capacity} {capacity > 1 ? "people" : "person"}</p>
                                </div>
                                
                            </div>
                            <button className="cart-delete-Btn mr-2" onClick={()=> this.props.deleteRoom("cartRooms", id, this.props.index)}><FaTrash style={{color:"red"}} /> Remove</button>
                            <span className="cart-delete-Btn" onClick={()=> redirectToSingleRoom()}><FaEye/> Show more details</span>
                        </td>
                        <td>
                            <div className="cart-nights">
                                <button onClick={()=> handlePriceChange("increase") } ><FaChevronUp/></button>
                                    {this.state.nights}
                                <button onClick={()=> handlePriceChange("decrease")}><FaChevronDown/></button>
                            </div>
                        </td>
                        <td>
                            <div className="cart-price">${this.state.currentPrice}</div>
                        </td>
                        
                    </tr>
                    
                </tbody>
            </Fragment>
        )
    }
    
}
export default withRouter(Cart);